import React, { useState } from "react";
import "./index.less";
import { trackGdp } from "../../../../utils/gio-report";

interface TabSwitcherProps {
  /** 我的邀请tab对应的展示组件 */
  MyInviteComponent: () => React.ReactElement;
  /** 邀请排行榜tab对应的展示组件 */
  InviteRankingComponent: () => React.ReactElement | null;
  /** 我的奖励tab对应的展示组件 */
  MyRewardComponent?: React.ComponentType<any> | React.ReactNode;
  activeIndex?: number;
  switchCallback?: Function;
  activityCode?: any;
}

const TabSwitcher: React.FC<TabSwitcherProps> = ({
  MyInviteComponent,
  InviteRankingComponent,
  MyRewardComponent,
  activeIndex = 0,
  switchCallback,
  activityCode
}) => {
  const [tabStatus, setTabStatus] = useState(activeIndex);

  const handleTabChange = (status: number) => {
    const BidEnums = {
      0 : 'B014',
      1 : 'B015',
      2 : 'B016',
    }
    trackGdp("P20082", BidEnums[status], {
      activityId: activityCode
    });
    setTabStatus(status);
    switchCallback && switchCallback(status)
  };

  // 渲染当前选中tab对应的组件
  const renderTabContent = () => {
    let currentComponent: React.ComponentType<any> | React.ReactNode | undefined;

    switch (tabStatus) {
      case 0:
        currentComponent = MyInviteComponent;
        break;
      case 1:
        currentComponent = InviteRankingComponent;
        break;
      case 2:
        currentComponent = MyRewardComponent;
        break;
      default:
        currentComponent = MyInviteComponent;
    }

    if (!currentComponent) {
      return null;
    }

    // 如果是React组件类型，则渲染组件；如果是ReactNode，则直接返回
    if (typeof currentComponent === 'function') {
      const Component = currentComponent as React.ComponentType<any>;
      return <Component />;
    } else {
      return currentComponent as React.ReactNode;
    }
  };

  return (
    <div className="tab-switcher">
      <img
        className={`tab-switcher-icon ${tabStatus !== 0 && "disabled"}`}
        src={'https://s.xiaopeng.com/xp-charge/charge/invite-new-guest/my-invite-bg.png'}
        alt="tab-switcher-icon"
      />
      <img
        className={`tab-switcher-icon ${tabStatus !== 1 && "disabled"}`}
        src={'https://s.xiaopeng.com/xp-charge/charge/invite-new-guest/invite-ranking-bg.png'}
        alt="tab-switcher-icon"
      />
      <img
        className={`tab-switcher-icon ${tabStatus !== 2 && "disabled"}`}
        src={'https://s.xiaopeng.com/xp-charge/charge/invite-new-guest/my-reward-bg.png'}
        alt="tab-switcher-icon"
      />
      <div className="tab-switcher-btn">
        <div
          className="tab-switcher-btn-item"
          onClick={() => handleTabChange(0)}
        />
        <div
          className="tab-switcher-btn-item"
          onClick={() => handleTabChange(1)}
        />
        <div
          className="tab-switcher-btn-item"
          onClick={() => handleTabChange(2)}
        />
      </div>
      {/* 渲染当前选中tab对应的组件内容 */}
      <div className="tab-content">
        {renderTabContent()}
      </div>
    </div>
  );
};

export default TabSwitcher;
